import React, {useEffect, useState} from 'react';
import Modal from '../../common/components/Modal';
import {
    Container,
    Form,
    Row,
    Col,
    Spinner,
    Button,
} from 'react-bootstrap';

import {getById, downloadListMatchReport} from '../../common/services/ListService';
import './DownloadListMatchReportDialog.scss';
import FormTextInput from "../../common/components/FormTextInput";
import FormContainer from "../../common/components/layout/FormContainer";
import {APP_COLORS} from "../../common/Constants";

function DownloadListMatchReportDialog(props) {
    const {
        handleClose,
        id,
    } = props;
    const [selectedList, setSelectedList] = useState(null);
    const [loading, setLoading] = useState(true);

    const [downloadResult, setDownloadResult] = useState(null);
    const [generateReportError, setGenerateReportError] = useState(null);

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const list = await getById(id);
            setSelectedList(list);
            setLoading(false);
        };
        init();

    }, [id]);

    const handleCreateListMatchReport = async (data) => {
        setLoading(true);
        setGenerateReportError(undefined);
        setDownloadResult(undefined);
        try {
            const downloadURL = await downloadListMatchReport(id);
            setDownloadResult(downloadURL);
            setLoading(false);
            setGenerateReportError(undefined);
        } catch (e) {
            setDownloadResult(undefined);
            setGenerateReportError('Report could not be generated.')
            setLoading(false);
        }
    };

    return (
        <Modal
            showClose={true}
            show={true}
            handleClose={handleClose}
            dialogClassName={'dialog'}
            title={`Download List Match Report`}
            footer={
                (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>

                        <Button
                            variant='info'
                            disabled={loading || !!downloadResult}
                            onClick={() => handleCreateListMatchReport()}
                        >
                            {!loading && <>Download</>}
                            {loading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                        </Button>
                        <Button
                            disabled={loading}
                            variant='outline-secondary'
                            onClick={() => handleClose()}
                            style={{marginLeft: '10px'}}
                        >
                            Cancel
                        </Button>
                    </div>
                )
            }
        >
            {loading && !selectedList?
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Spinner
                        style={{marginTop: '30px'}}
                        as="span"
                        animation="border"
                        role="status"
                        aria-hidden="true"
                        variant="info"
                    />
                </div>
                :
                <Container className="container">
                    <FormContainer>
                        <Form noValidate>
                            <Row style={{
                                marginTop: '10px',
                                paddingBottom: '0px'
                            }}>
                                <Col md={12}>
                                    <FormTextInput
                                        label={'Data Type'}
                                        value={'pdf'}
                                        size={'sm'}
                                        disabled
                                    />
                                </Col>
                            </Row>
                            <Row style={{
                                marginTop: '10px',
                                paddingBottom: '0px'
                            }}>
                                <Col md={12}>
                                    <FormTextInput
                                        label={'Name'}
                                        value={selectedList?.name}
                                        size={'sm'}
                                        disabled
                                    />
                                </Col>
                            </Row>
                        </Form>
                        {!downloadResult &&
                            <Row>
                                <Col>
                                    <span style={{
                                        fontStyle: 'italic',
                                        fontSize: '14px'
                                    }}>Select download to generate a link for your match report.</span>
                                </Col>
                            </Row>
                        }
                        {downloadResult &&
                            <Row>
                                <Col>
                                    <span style={{
                                        fontStyle: 'italic',
                                        fontSize: '14px'
                                    }}> Your Match Report is ready. Click the link below to download the list match report.</span>
                                    <br/>
                                    <br/>
                                    <div>
                                        <a href={`${downloadResult}`} target={'_blank'}
                                           style={{
                                               // fontStyle: 'italic',
                                               // textDecoration: 'underline',
                                               color: APP_COLORS.orange
                                           }}
                                        >
                                            {`${selectedList.name}.pdf`}
                                        </a>
                                    </div>
                                </Col>
                            </Row>
                        }
                        {generateReportError &&
                            <Row>
                                <Col>
                                    <span style={{
                                        fontStyle: 'italic',
                                        fontSize: '14px',
                                        color: APP_COLORS.red
                                    }}> Cannot generate your Match Report. Please contact admin.</span>
                                    <br/>
                                    <br/>
                                </Col>
                            </Row>
                        }
                    </FormContainer>
                </Container>
            }
        </Modal>
    );
}
export default DownloadListMatchReportDialog;
